export default __webpack_public_path__ + "static/media/svg-1.6250b486.svg";